import styled from 'styled-components';
import { Row } from 'components/layout';

export const Header = styled(Row)`
  width: 100%;
  justify-content: space-between;
`;
